/*
 * AUTO-GENERATED FILE. DO NOT MODIFY
 *
 * This file was automatically generated by the
 * npm run generate-design-token command, and it
 * should not be modified by hand.
 */

export const MessageCardSizeDefault = '40px'
export const MessageCardSizeTable = '32px'
export const MessageCardSizeIcon = '32px'
export const MessageCardSizeTextMinWidth = '138px'
export const MessageCardBorderRadius = '5px'
export const MessageCardBorderWidthNormal = '1px'
export const MessageCardSpacingDefaultLeft = '16px'
export const MessageCardSpacingDefaultRight = '8px'
export const MessageCardSpacingDefaultVertical = '8px'
export const MessageCardSpacingDefaultGap = '16px'
export const MessageCardSpacingDefaultTextRight = '8px'
export const MessageCardSpacingTableLeft = '8px'
export const MessageCardSpacingTableRight = '8px'
export const MessageCardSpacingTableVertical = '0px'
export const MessageCardSpacingTableGap = '16px'
export const MessageCardSpacingTableTextRight = '8px'
export const MessageCardColorInfoBackground = '#fafafa'
export const MessageCardColorInfoOnBackground = '#424242'
export const MessageCardColorInfoOutline = '#ffffff00'
export const MessageCardColorInfoIcon = '#00000061'
export const MessageCardColorWarningBackground = '#fff3e0'
export const MessageCardColorWarningOnBackground = '#664A33'
export const MessageCardColorWarningOutline = '#ffffff00'
export const MessageCardColorWarningIcon = '#664A33'
export const MessageCardColorErrorBackground = '#fbe9e7'
export const MessageCardColorErrorOnBackground = '#d84315'
export const MessageCardColorErrorOutline = '#ffffff00'
export const MessageCardColorErrorIcon = '#d84315'
export const MessageCardColorSuccessBackground = '#f1f8e9'
export const MessageCardColorSuccessOnBackground = '#558b2f'
export const MessageCardColorSuccessOutline = '#ffffff00'
export const MessageCardColorSuccessIcon = '#558b2f'
export const MessageCardColorUpsellBackground = '#fff4ec'
export const MessageCardColorUpsellOnBackground = '#004D3B'
export const MessageCardColorUpsellOutline = '#ffffff00'
export const MessageCardColorUpsellIcon = '#004D3B'
